module.exports = __webpack_public_path__ + "static/media/goodOldDays.c084262c.webp";